import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

/**
 * Resolves the currently active map for a visitor session.
 * Result is pinned for the session via staleTime: Infinity — fresh resolution
 * only happens on page refresh (new React Query cache).
 */
export function useActiveMapQuery(orgSlug: string) {
  const query = useQuery({
    queryKey: ["active-map", orgSlug],
    queryFn: async () => {
      const res = await api.maps.active[":orgSlug"].$get({
        param: { orgSlug },
      });
      if (!res.ok) {
        const error = await res.json();
        throw new Error("error" in error ? error.error : "Failed to resolve active map");
      }
      return res.json();
    },
    enabled: !!orgSlug,
    staleTime: Infinity, // Pin for session — don't re-resolve until page refresh
  });

  return {
    mapId: query.data?.mapId ?? null,
    mapSlug: query.data?.mapSlug ?? null,
    reason: query.data?.reason ?? null,
    isLoading: query.isLoading,
    error: query.error,
  };
}
